const GOOGLE_MAPS_API_KEY = "AIzaSyA6wkltC3dhVVMm6dqS2Vdv_SgCZ3ZbmzE";

let mapsPromise: Promise<void> | null = null;

const loadGoogleMaps = (): Promise<void> => {
    if (mapsPromise) return mapsPromise;
    mapsPromise = new Promise((resolve, reject) => {
        if ((window as any).google && (window as any).google.maps && (window as any).google.maps.DistanceMatrixService) {
            resolve();
            return;
        }
        
        // Attach random callback name to avoid collisions
        const callbackName = 'initMapCallback_' + Math.round(Math.random() * 1000000);
        (window as any)[callbackName] = () => {
             resolve();
             delete (window as any)[callbackName]; // cleanup
        };

        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=geometry&loading=async&callback=${callbackName}`;
        script.async = true;
        script.defer = true;
        
        script.onerror = () => reject(new Error('Google Maps SDK failed to load'));
        document.head.appendChild(script);
    });
    return mapsPromise;
};

export const filterCitiesByRadius = async (origin: string, destinations: string[], maxKm: number): Promise<string[]> => {
    if (!origin || !destinations || destinations.length === 0 || maxKm <= 0) return destinations; 
    
    await loadGoogleMaps();
    
    const uniqueDestinations = Array.from(new Set(destinations)).filter(d => d && d.trim().length > 0);
    const CHUNK_SIZE = 25;
    const allowedCities: string[] = [];
    const service = new (window as any).google.maps.DistanceMatrixService();

    for (let i = 0; i < uniqueDestinations.length; i += CHUNK_SIZE) {
        const chunk = uniqueDestinations.slice(i, i + CHUNK_SIZE);
        try {
            const response = await new Promise<any>((resolve, reject) => {
                service.getDistanceMatrix({
                    origins: [origin + ', Netherlands'],
                    destinations: chunk.map(d => d + ', Netherlands'),
                    travelMode: (window as any).google.maps.TravelMode.DRIVING,
                }, (response: any, status: any) => {
                    if (status === 'OK') resolve(response);
                    else reject(new Error('DistanceMatrix Error: ' + status));
                });
            });
            
            if (response && response.rows && response.rows.length > 0) {
                const elements = response.rows[0].elements;
                elements.forEach((element: any, index: number) => {
                    if (element.status === 'OK' && element.distance && element.distance.value !== undefined) {
                        const distanceKm = element.distance.value / 1000;
                        if (distanceKm <= maxKm) {
                            allowedCities.push(chunk[index]);
                        }
                    } else if (element.status === 'ZERO_RESULTS') {
                        // Try string contains as a fallback
                    }
                });
            } else {
                 console.warn("Maps API error status:", response);
            }
        } catch (error) {
             console.error("Error fetching Distance Matrix: ", error);
        }
    }
    
    // Always include the origin itself just in case
    allowedCities.push(origin);
    
    // Return lowercase version to allow case-insensitive comparisons
    return Array.from(new Set(allowedCities.map(c => c.toLowerCase())));
};

export const getCityDistancesKms = async (origin: string, destinations: string[]): Promise<Record<string, number>> => {
    if (!origin || !destinations || destinations.length === 0) return {};
    
    await loadGoogleMaps();
    
    const uniqueDestinations = Array.from(new Set(destinations)).filter(d => d && d.trim().length > 0);
    const CHUNK_SIZE = 25;
    const distances: Record<string, number> = {};
    const service = new (window as any).google.maps.DistanceMatrixService();

    for (let i = 0; i < uniqueDestinations.length; i += CHUNK_SIZE) {
        const chunk = uniqueDestinations.slice(i, i + CHUNK_SIZE);
        try {
            const response = await new Promise<any>((resolve, reject) => {
                service.getDistanceMatrix({
                    origins: [origin + ', Netherlands'],
                    destinations: chunk.map(d => d + ', Netherlands'),
                    travelMode: (window as any).google.maps.TravelMode.DRIVING,
                }, (response: any, status: any) => {
                    if (status === 'OK') resolve(response);
                    else reject(new Error('DistanceMatrix Error: ' + status));
                });
            });
            
            if (response && response.rows && response.rows.length > 0) {
                const elements = response.rows[0].elements;
                elements.forEach((element: any, index: number) => {
                    if (element.status === 'OK' && element.distance && element.distance.value !== undefined) {
                        const distanceKm = Math.round((element.distance.value / 1000) * 10) / 10;
                        distances[chunk[index].toLowerCase()] = distanceKm;
                    }
                });
            }
        } catch (error) {
             console.error("Error fetching Distance Matrix: ", error);
        }
    }
    
    return distances;
};
